import React from "react";
import { object, string, bool } from "prop-types";
import AuthorSlug from "../author-name";
import "./author-info.m.css";


const AuthorInfo = ({ story, isHeroImage = true }) => {
//console.log("StoryHeader",story)

//  const authorSlug = get(story, ["authors", 0, "slug"], "");
//  const paikkakunta = get(story, ["metadata", "paikkakunta"], []);

  return (
    <div styleName="wrapper">
        <React.Fragment>
          <AuthorSlug authors={story.authors}/>
          {/*<div styleName="authors">
            <Link href={`/author/${authorSlug}`} styleName="author-img">
              <ul>
                {story.authors.map(author =>
                  <li>{author.name}</li>
                )}
              </ul>
           </Link>
          </div>*/}
          {/*paikkakunta.length > 0 && (<div styleName="section-place">

            <Link styleName="place">{paikkakunta} </Link>
                </div>)*/}
        </React.Fragment>
    </div>
  );
};

AuthorInfo.propTypes = {
  story: object,
  sectionName: string,
  isHeroImage: bool
};

export default AuthorInfo;
